export default "__VITE_ASSET__BftydZ7y__"